import { format, parseDateFromApi } from '@sequencehq/utils/dates'

import { TotalViewsForDate } from '../../../types'

const DATE_FORMAT = 'd MMM yyyy'

export const getInsightsCaption = (
  viewData: TotalViewsForDate[]
): string | undefined => {
  const viewDataOrdered = viewData.sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
  )

  const firstDate = viewDataOrdered.at(0)?.date
  const lastDate = viewDataOrdered.at(-1)?.date

  if (!firstDate || !lastDate) return undefined

  if (firstDate === lastDate) {
    return format(parseDateFromApi(firstDate) ?? '', DATE_FORMAT)
  }

  return [
    format(parseDateFromApi(firstDate) ?? '', DATE_FORMAT),
    '–',
    format(parseDateFromApi(lastDate) ?? '', DATE_FORMAT)
  ].join(' ')
}
